import { rankingItems } from '@/mocks/homeMangaData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">热度榜单</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            实时更新的热门漫画排行，看看大家都在追什么完结作品
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingItems.map((item, idx) => (
            <div
              key={item.id}
              className={`group flex items-center gap-4 p-4 md:p-5 border-b border-background-200/60 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer ${
                idx === 0 ? 'bg-background-50 rounded-t-xl border-t border-background-200/60' : ''
              } ${idx === rankingItems.length - 1 ? 'rounded-b-xl' : ''}`}
            >
              <div className={`flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center font-heading font-bold text-sm md:text-base ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</span>
                  <span className={`flex-shrink-0 px-1.5 py-0.5 ${item.tagColor} text-background-50 rounded text-[10px] font-semibold`}>
                    {item.tag}
                  </span>
                </div>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5 text-xs md:text-sm font-semibold text-accent-600">
                <i className="ri-fire-fill text-accent-500"></i>
                {item.heat}阅读
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}